import React from "react"
import { Link } from "gatsby"

const Navigation = props => {
  return (
    <nav className={props.mobileNavIsOpen ? "navigation open" : "navigation"}>
      <ul>
        <li>
          {/* onClick calls the toggleMobileNav function in header.js */}
          <Link to="/about/" onClick={props.clickHandler}>
            About
          </Link>
        </li>
        <li>
          <Link to="/experience/" onClick={props.clickHandler}>
            Experience
          </Link>
        </li>
        {/* <li>
          <Link to="/" onClick={props.clickHandler}>
            Skills
          </Link>
        </li> */}
        {/* <li>
          <Link to="/" onClick={props.clickHandler}>
            Portfolio
          </Link>
        </li> */}
        <li>
          <Link to="/contact/" onClick={props.clickHandler}>
            Contact
          </Link>
        </li>
        {/* <li>
          <button>Theme Switcher</button>
        </li> */}
      </ul>
    </nav>
  )
}

export default Navigation
